<template>
  <div class="row pt-3">
    <div class="col-md-3" v-if="content.data && content.data.length > 0">
      <div class="div-filter" v-if="!mobile">
        <!-- Categorías -->
        <div class="filter-box">
          <div class="titulo_sidebar" v-if="childs.length > 0">
            <h4>{{ item22 }}</h4>
          </div>

          <div class="item-filter-bra">
            <a-tree
              v-model="checkedCategoryKeys"
              :expanded-keys="expandedCategoryKeys"
              :selected-keys="selectedCategoryKeys"
              :tree-data="categoriesTreeData"
              @expand="onExpandCategory"
              @select="onSelectCategory"
              checkable
            >
              <span slot-scope="title">{{ title }}</span>
            </a-tree>
          </div>
        </div>

        <!-- Marca -->
        <div class="filter-box">
          <div class="titulo_sidebar" v-if="brands.length > 0">
            <h4>{{ item19 }}</h4>
          </div>
          <div class="input_sidebar">
            <i class="fa fa-search icon"></i>
            <input
              type="text"
              v-model="inputBrand"
              autocomplete="off"
              placeholder="Buscar marca..."
            />
          </div>
          <div class="item-filter-bra">
            <a-tree
              checkable
              v-model="checkedBrandKeys"
              :expanded-keys="expandedBrandKeys"
              :selected-keys="selectedBrandKeys"
              :tree-data="brandsTreeData"
              @expand="onExpandBrand"
              @select="onSelectBrand"
            >
              <span slot-scope="title">{{ title }}</span>
            </a-tree>
          </div>
          <div class="mt-2">
            <a-button
              class="p-0"
              :icon="iconButton"
              type="link"
              @click="toggleVisibleBrands"
              v-if="this.brands.length > 10"
              >{{
                this.brands.filter(
                  (b) =>
                    b.visible &&
                    (this.inputBrand == "" ||
                      b.name
                        .toLowerCase()
                        .includes(this.inputBrand.toLowerCase()))
                ).length <= 10
                  ? item6
                  : item7
              }}</a-button
            >
          </div>
          <div
            class="item-empty-bra mt-2"
            v-if="
              this.brands.filter(
                (b) =>
                  b.visible &&
                  (this.inputBrand == '' ||
                    b.name
                      .toLowerCase()
                      .includes(this.inputBrand.toLowerCase()))
              ).length == 0
            "
          >
            <span>{{ transPeralbaPro.item1008 }}</span>
          </div>
        </div>

        <!-- Precio -->
        <div class="filter-box">
          <div class="titulo_sidebar">
            <h4>{{ transPeralbaPro.item903 }}</h4>
          </div>
          <div class="contenedor-slider">
            <div
              class="slider-track"
              id="slider-price-track"
              :style="myStylePrice"
            ></div>
            <input
              type="range"
              min="0"
              :max="sliderMaxValuePrice"
              v-model="sliderPriceOneValue"
              id="slider-price-1"
              @change="slideOnePrice"
            />
            <input
              type="range"
              min="0"
              :max="sliderMaxValuePrice"
              v-model="sliderPriceTwoValue"
              id="slider-price-2"
              @change="slideTwoPrice"
            />
          </div>
          <div class="values">
            <div class="input-filter-price">
              <label>Min. (€)</label>
              <p>{{ sliderPriceOneText }}</p>
            </div>
            <div class="input-filter-price">
              <label>Max. (€)</label>
              <p>{{ sliderPriceTwoText }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- modal filtros mobile -->

      <!-- Modal -->
      <div
        class="modal right fade"
        id="filtersModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="filtersModalLabel"
        v-else
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header modal-header-filters">
              <h5 class="modal-title" id="filtersModalLabel">
                {{ transPeralbaPro.item904 }}
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body modal-body-filters mobile-mb-4">
              <div class="div-filter">
                <div class="filter-box">
                  <div class="titulo_sidebar" v-if="childs.length > 0">
                    <h4>{{ item22 }}</h4>
                  </div>

                  <div class="item-filter-bra">
                    <a-tree
                      v-model="checkedCategoryKeys"
                      :expanded-keys="expandedCategoryKeys"
                      :selected-keys="selectedCategoryKeys"
                      :tree-data="categoriesTreeData"
                      @expand="onExpandCategory"
                      @select="onSelectCategory"
                      checkable
                    >
                      <span slot-scope="title">{{ title }}</span>
                    </a-tree>
                  </div>
                </div>

                <!-- Marca -->
                <div class="filter-box">
                  <div class="titulo_sidebar" v-if="brands.length > 0">
                    <h4>{{ item19 }}</h4>
                  </div>
                  <div class="input_sidebar">
                    <i class="fa fa-search icon"></i>
                    <input
                      type="text"
                      v-model="inputBrand"
                      autocomplete="off"
                      placeholder="Buscar marca..."
                    />
                  </div>
                  <div class="item-filter-bra">
                    <a-tree
                      checkable
                      v-model="checkedBrandKeys"
                      :expanded-keys="expandedBrandKeys"
                      :selected-keys="selectedBrandKeys"
                      :tree-data="brandsTreeData"
                      @expand="onExpandBrand"
                      @select="onSelectBrand"
                    >
                      <span slot-scope="title">{{ title }}</span>
                    </a-tree>
                  </div>
                  <div class="mt-2">
                    <a-button
                      class="p-0"
                      :icon="iconButton"
                      type="link"
                      @click="toggleVisibleBrands"
                      v-if="this.brands.length > 10"
                      >{{
                        this.brands.filter(
                          (b) =>
                            b.visible &&
                            (this.inputBrand == "" ||
                              b.name
                                .toLowerCase()
                                .includes(this.inputBrand.toLowerCase()))
                        ).length <= 10
                          ? item6
                          : item7
                      }}</a-button
                    >
                  </div>
                  <div
                    class="item-empty-bra mt-2"
                    v-if="
                      this.brands.filter(
                        (b) =>
                          b.visible &&
                          (this.inputBrand == '' ||
                            b.name
                              .toLowerCase()
                              .includes(this.inputBrand.toLowerCase()))
                      ).length == 0
                    "
                  >
                    <span>{{ transPeralbaPro.item1008 }}</span>
                  </div>
                </div>

                <!-- Precio -->
                <div class="filter-box">
                  <div class="titulo_sidebar">
                    <h4>{{ transPeralbaPro.item903 }}</h4>
                  </div>
                  <div class="contenedor-slider">
                    <div
                      class="slider-track"
                      id="slider-price-track"
                      :style="myStylePrice"
                    ></div>
                    <input
                      type="range"
                      min="0"
                      :max="sliderMaxValuePrice"
                      v-model="sliderPriceOneValue"
                      id="slider-price-1"
                      @change="slideOnePrice"
                    />
                    <input
                      type="range"
                      min="0"
                      :max="sliderMaxValuePrice"
                      v-model="sliderPriceTwoValue"
                      id="slider-price-2"
                      @change="slideTwoPrice"
                    />
                  </div>
                  <div class="values">
                    <div class="input-filter-price">
                      <label>Min. (€)</label>
                      <p>{{ sliderPriceOneText }}</p>
                    </div>
                    <div class="input-filter-price">
                      <label>Max. (€)</label>
                      <p>{{ sliderPriceTwoText }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer modal-footer-filters mobile-fixed-bottom">
              <button
                type="button"
                class="btn-per-dark w-100"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {{ transPeralbaPro.item905 }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3" v-else></div>
    <div class="col-md-9" v-if="content.data && content.data.length > 0">
      <page-control
        :query="query"
        :item10="item10"
        :item11="item11"
        :item12="item12"
        :item13="item13"
        :item14="item14"
        :count="content.total"
        :template="templateVal"
        :mobile="mobile"
        :trans-peralba-pro="transPeralbaPro"
        :productsCountToShow="productsCountToShow"
        :order="order"
        @onOrderChange="handleOrderChange"
        @onQuantityChange="handleQuantityChange"
        @onChangeTemplate="handleVisibleTemplate"
      />
      <div class="lista-table product grid_productos" id="grid_productos">
        <div class="row">
          <product-item
            :template="templateVal"
            :mobile="mobile"
            :item24="item24"
            :item25="item25"
            :item26="item26"
            v-for="product in content.data"
            :product="product"
            :key="product.id"
            :user="user"
            :warehouse="warehouse"
            :trans-peralba-pro="transPeralbaPro"
            :locale="locale"
            :can-write-orders="canWriteOrders"
            @onUpdatePrice="handleUpdatePrice($event, product)"
            @product-added="handleProductAdded"
            @selled-products="handleSelledProducts"
          />
        </div>
      </div>
      <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li
            v-for="(item, idx) in visibleLinks"
            :key="idx"
            class="page-item"
            :class="[
              item.active   ? 'active'   : '',
              item.url === null ? 'disabled' : ''
            ]"
          >
            <a
              class="page-link"
              :href="item.url ? paginatedLink(item.url) : '#'"
            >
              {{ replaceItemLabel(item.label) }}
            </a>
          </li>
        </ul>
      </nav>
    </div>
    <div class="col-md-9" v-else>
      <div
        class="col-12 p-0"
        v-if="mobile && content.data && content.data.length >= 0"
      >
        <button
          type="button"
          class="btn-per-filtros mt-2"
          data-bs-toggle="modal"
          data-bs-target="#filtersModal"
        >
          <img src="/front/hi/filter.svg" /> {{ transPeralbaPro.item902 }}
        </button>
      </div>
      <div
        class="peralba-empty"
        v-if="content.data && content.data.length == 0"
      >
        <img :src="'/front/hi/peralba-empty.svg'" />
        <h4>
          {{ item23 }} <span>{{ query }}</span
          >.
        </h4>
        <h5>{{ item24 }}</h5>
      </div>
      <div class="peralba-empty" v-else>
        <img :src="'/front/hi/peralba-empty.svg'" />
        <h4>{{ item26 }}</h4>
        <h5>{{ item27 }}</h5>
      </div>
    </div>

    <div
      class="modal right fade"
      id="addedProductModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="
    addedProductModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addedProductModalLabel">
              {{ transPeralbaPro.item888 }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="sidebar-header">
              <a
                class="sidebar-suggestion"
                v-if="added_product"
                :href="added_product.href"
              >
                <img
                  :src="added_product.images[0].thumbnail"
                  :alt="added_product.name"
                  width="120"
                />
                <div class="item_sidebar w-100">
                  <h5 class="ref" v-if="added_product.alias_code">
                    {{ added_product.alias_code }}
                  </h5>
                  <h5 class="ref" v-else>
                    {{ added_product.erp_reference }}
                  </h5>
                  <h4 class="desc">{{ added_product.translation.name }}</h4>
                  <div
                    v-if="parseFloat(added_product.discount_) > 0"
                    class="container-prices"
                  >
                    <div class="container-offer">
                      <p class="pvp-title">{{ transPeralbaPro.item882 }}</p>
                      <p class="pvp-offer red">
                        {{ parseFloat(added_product.price_) | currency }}
                      </p>
                    </div>
                    <div class="container-pvp">
                      <p class="pvp-title">{{ transPeralbaPro.item132 }}</p>
                      <div class="d-flex">
                        <p class="pvp-value">
                          {{
                            parseFloat(added_product.price_without_discount_)
                              | currency
                          }}
                        </p>
                        <span class="offer"
                          >-{{
                            parseFloat(added_product.discount_) | percentage
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div v-else class="container-offer">
                    <p class="pvp-title">{{ transPeralbaPro.item132 }}</p>
                    <p class="pvp-offer">
                      {{ parseFloat(added_product.price) | currency }}
                    </p>
                  </div>
                </div>
              </a>
              <div class="row sidebar-buttons-row">
                <div class="col-lg-6 col-md-6 col-xs-12 col-12">
                  <button
                    class="btn-per-dark-outlined w-100 text-center"
                    role="button"
                    id="dismiss2"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    {{ transPeralbaPro.item889 }}
                  </button>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12 col-12">
                  <a
                    class="btn-per-dark w-100 text-center"
                    :href="cartUrl"
                    role="button"
                  >
                    {{ transPeralbaPro.item890 }}
                  </a>
                </div>
              </div>
            </div>
            <hr />
            <div class="sidebar-content">
              <div class="sidebar-content-title">
                <h5 class="modal-title">{{ transPeralbaPro.item891 }}</h5>
              </div>
              <ul
                class="list-unstyled components"
                v-if="selled_products && selled_products.length"
              >
                <template v-for="product in selled_products">
                  <a class="sidebar-suggestion" :href="product.href">
                    <img
                      :src="product.images[0].thumbnail"
                      :alt="product.name"
                    />
                    <div class="item_sidebar w-100">
                      <h5 class="ref" v-if="product.alias_code">
                        {{ product.alias_code }}
                      </h5>
                      <h5 class="ref" v-else>
                        {{ product.erp_reference }}
                      </h5>
                      <h4 class="desc">{{ product.translation.name }}</h4>
                      <div
                        v-if="parseFloat(product.discount_) > 0"
                        class="container-prices"
                      >
                        <div class="container-offer">
                          <p class="pvp-title">{{ transPeralbaPro.item882 }}</p>
                          <p class="pvp-offer red">
                            {{ parseFloat(product.price_) | currency }}
                          </p>
                        </div>
                        <div class="container-pvp">
                          <p class="pvp-title">{{ transPeralbaPro.item132 }}</p>
                          <div class="d-flex">
                            <p class="pvp-value">
                              {{
                                parseFloat(product.price_without_discount_)
                                  | currency
                              }}
                            </p>
                            <span class="offer"
                              >-{{
                                parseFloat(product.discount_) | percentage
                              }}</span
                            >
                          </div>
                        </div>
                      </div>
                      <div v-else class="container-offer">
                        <p class="pvp-title">{{ transPeralbaPro.item132 }}</p>
                        <p class="pvp-offer">
                          {{ parseFloat(product.price) | currency }}
                        </p>
                      </div>
                      <div class="row-bottom pt-4">
                        <form method="POST" class="add-shopping-cart-form">
                          <input
                            type="hidden"
                            name="product_id"
                            :value="product.id"
                          />
                          <input
                            type="hidden"
                            name="quantity"
                            :value="product.minimum > 0 ? product.minimum : 1"
                          />

                          <div class="add-cart w-75">
                            <button
                              type="button"
                              @click.prevent="addToShoppingCart($event)"
                              class="btn-per-dark w-75"
                            >
                              {{ transPeralbaPro.item896 }}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </a>
                  <hr />
                </template>
              </ul>
              <ul class="list-unstyled components" v-else>
                <div class="row">
                  <div class="col-md-12 text-center pb-2 pt-2" id="loading">
                    <img
                      class="img-responsive"
                      src="/front/img/general/loader.gif"
                    />
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { uppercase, currency, percentage } from "./utils/filters.js";
import ProductItem from "./components/ProductItem";
import PageControl from "./components/PageControl";
import axios from "axios";
Vue.filter("uppercase", uppercase);
Vue.filter("currency", currency);
Vue.filter("percentage", percentage);

function debounce(fn, delay) {
  var timeoutID = null;
  return function() {
    clearTimeout(timeoutID);
    var args = arguments;
    var that = this;
    timeoutID = setTimeout(function() {
      fn.apply(that, args);
    }, delay);
  };
}

export default {
  props: [
    "content",
    "user",
    "query",
    "item1",
    "item2",
    "item3",
    "item4",
    "item5",
    "item6",
    "item7",
    "item8",
    "item9",
    "item10",
    "item11",
    "item12",
    "item13",
    "item14",
    "item15",
    "item16",
    "item17",
    "item18",
    "item19",
    "item20",
    "item21",
    "item22",
    "item23",
    "item24",
    "item25",
    "item26",
    "item27",
    "childs",
    "childsCategories",
    "warehouse",
    "maxPrice",
    "minPrice",
    "template",
    "mobile",
    "transPeralbaPro",
    "locale",
    "canWriteOrders",
    "filterCategories",
    "filterBrands",
    "filterOrder",
    "filterPerPage",
    "filterMinPrice",
    "filterMaxPrice",
    "filterQuery",
    "cartUrl",
  ],

  components: {
    ProductItem,
    PageControl,
  },
  data() {
    return {
      expandedCategoryKeys: [],
      selectedCategoryKeys: [],
      checkedCategoryKeys: [],
      iconButton: "down",
      inputBrand: "",
      productsCountToShow: 25,
      sliderVal: "",
      templateVal: 0,
      sliderTrackPrice: $("#slider-price-track"),
      sliderPriceOneValue: 0,
      sliderPriceTwoValue: 0, // 32
      sliderPriceOneValueOld: 0,
      sliderPriceTwoValueOld: 0, // 32
      sliderMaxValuePrice: 0, // 32
      minGapPrice: 0,
      sliderPriceOneText: "0€",
      sliderPriceTwoText: "+9,500€",
      values: [],
      myStylePrice: {
        background: "#D9D9D9",
      },
      selectedBrandKeys: [],
      checkedBrandKeys: [],
      expandedBrandKeys: [],
      filteredByBrand: [],
      filteredByCategory: [],
      order: undefined,
      limit: 10,
      added_product: null,
      selled_products: [],
      isMobile: window.innerWidth <= 768,
    };
  },
  computed: {
    visibleLinks() {
      const links = this.content.links
      const total = links.length

      // Definimos límite y delta según móvil o desktop
      const maxButtons   = this.isMobile ? 4  : 10
      const delta        = this.isMobile ? 2  : 4
      const edgeCount    = 2               // primera + última

      // Si no supera el máximo, devolvemos todo
      if (total <= maxButtons) {
        return links
      }

      // Encuentra la posición actual
      const current = links.findIndex(i => i.active)
      // Calcula ventana central
      let start = Math.max(current - delta, 1)
      let end   = Math.min(current + delta, total - edgeCount)

      // Ajusta si demasiado cerca de los bordes
      if (current - start < delta) {
        end = Math.min(start + 2*delta, total - edgeCount)
      }
      if (end - current < delta) {
        start = Math.max(end - 2*delta, 1)
      }

      const out = []
      // 1) siempre la primera
      out.push(links[0])

      // 2) puntos si hay hueco antes
      if (start > 1) {
        out.push({ label: '...', url: null, active: false })
      }

      // 3) bloque central
      for (let i = start; i <= end; i++) {
        out.push(links[i])
      }

      // 4) puntos si hay hueco después
      if (end < total - edgeCount) {
        out.push({ label: '...', url: null, active: false })
      }

      // 5) siempre la última
      out.push(links[total - 1])

      return out
    },

    brands() {
      const brandMap = new Map();
      this.content.data.forEach((product) => {
        if (product.brand && !brandMap.has(product.brand.id)) {
          brandMap.set(product.brand.id, {
            ...product.brand,
            visible: brandMap.size < 10,
          });
        }
      });
      return Array.from(brandMap.values());
    },
    brandsTreeData() {
      return this.brands.map(this.mapBrandToTreeData);
    },
    categoriesTreeData() {
      return this.childs
        .filter((item) => item.show === true)
        .map(this.mapCategoriesToTreeData);
    },
    params() {
      return {
        q: this.filterQuery ?? "",
        categories: this.checkedCategoryKeys ?? "",
        brands: this.checkedBrandKeys ?? "",
        minPrice: this.convertPrice(this.sliderPriceOneValue) ?? "",
        maxPrice: this.convertPrice(this.sliderPriceTwoValue) ?? "",
        sortBy: this.order ?? "relevance",
        perPage: this.productsCountToShow ?? 25,
        page: this.content.current_page ?? 1,
      };
    },
    url() {
      var esc = encodeURIComponent;
      var query = Object.keys(this.params)
        .map((k) => esc(k) + "=" + esc(this.params[k]))
        .join("&");

      return window.location.origin + window.location.pathname + "?" + query;
    },
  },

  watch: {
    url: debounce(function(newValue, oldValue) {
      let oldQuery = oldValue.split("?")[1] ?? "";
      oldQuery = oldQuery.split("&perPage")[0];
      const initialQuery =
        "categories=&brands=&minPrice=&maxPrice=&sortBy=relevance";

      if (!oldQuery.includes(initialQuery) && newValue !== oldValue) {
        return (window.location.href = newValue);
      }
    }, 500),
  },

  created() {
    let categories = this.filterCategories.map((item) => item);
    let brands = this.filterBrands.map((item) => parseInt(item));

    this.checkedCategoryKeys = categories;
    this.selectedCategoryKeys = this.checkedCategoryKeys;
    this.expandedCategoryKeys = this.checkedCategoryKeys;

    this.checkedBrandKeys = brands;
    this.selectedBrandKeys = this.checkedBrandKeys;
    this.expandedBrandKeys = this.checkedBrandKeys;
    this.order = this.filterOrder ?? "relevance";
    this.productsCountToShow = this.filterPerPage ?? 25;
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    this.initializeTemplate();
    this.hideLoadingIndicator();
    this.populateSliderValues();
    this.initializeSliderState();
    this.scrollIfHasParams();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    addToShoppingCart($event) {
      const formData = Object.fromEntries(
        new FormData($event.target.form).entries()
      );
      const url = "/add-shopping-cart-product";
      axios
        .post(url, formData)
        .then((r) => {
          if (r.data.status == 1) {
            Array.prototype.forEach.call($(".number-cart"), function(el) {
              el.innerText = r.data.quantity_cart;
            });
            if (r.data.quantity_cart > 0) {
              Array.prototype.forEach.call($(".number-cart"), function(el) {
                el.classList.remove("d-none");
              });
            }

            throwNotify(this.transPeralbaPro.item567, "success", 2000);
            // window.location.reload()
          } else {
            throwNotify(this.transPeralbaPro.item568, "warning", 1000);
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally();
    },
    paginatedLink(link) {
      var page = 1;
      if (link) {
        page = link.split("page=")[1];
      }
      var params = this.params;
      params.page = page;
      var esc = encodeURIComponent;
      var query = Object.keys(params)
        .map((k) => esc(k) + "=" + esc(params[k]))
        .join("&");

      return window.location.origin + window.location.pathname + "?" + query;
    },
    toggleVisibleBrands() {
      if (this.brands.filter((b) => !b.visible).length > 0) {
        this.brands.forEach((b) => {
          this.$set(b, "visible", true);
        });
        this.iconButton = "up";
      } else {
        this.brands.forEach((b, i) => {
          if (i > 10) this.$set(b, "visible", false);
        });
        this.iconButton = "down";
      }
    },
    handleOrderChange(value) {
      this.order = value;
    },
    handleQuantityChange(value) {
      this.productsCountToShow = value;
    },
    handleVisibleProductsChange(count) {
      this.productsCountToShow = count;
    },
    onExpandCategory(expandedKeys) {
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedCategoryKeys = expandedKeys;
      this.autoExpandParent = false;
    },

    onSelectCategory(selectedKeys, info) {
      this.selectedCategoryKeys = selectedKeys;
    },
    onExpandBrand(expandedKeys) {
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedBrandKeys = expandedKeys;
      this.autoExpandParent = false;
    },

    onSelectBrand(selectedKeys, info) {
      this.selectedBrandKeys = selectedKeys;
    },
    isCategoryDisabled(category) {
      const productsInCategory = this.content.data.filter(
        (product) => product.category_code === category.catCode
      );
      return !productsInCategory.some((product) =>
        this.filteredByBrand.includes(product)
      );
    },

    mapBrandToTreeData(brand) {
      const isDisabled =
        this.filteredByCategory.length > 0 &&
        !this.filteredByCategory.some((p) => p.brand_id === brand.id);

      return {
        title: brand.name,
        key: brand.id,
        disabled: isDisabled,
      };
    },
    mapCategoriesToTreeData(category) {
      var childCategories = category.childrens
        .filter((item) => item.show === true)
        .map(this.mapCategoriesToTreeData);
      return {
        title: category.translation.name,
        key: category.codeElement,
        disabled: false,
        children: childCategories,
      };
    },
    initializeTemplate() {
      this.templateVal = this.template;
      if (this.mobile) {
        this.limit = 4;
      }
    },

    hideLoadingIndicator() {
      this.$nextTick(() => {
        const element = document.getElementById("loading");
        if (element) {
          element.classList.add("d-none");
        }
      });
    },

    populateSliderValues() {
      const possibleValues = [
        0,
        5,
        10,
        25,
        50,
        100,
        150,
        200,
        300,
        350,
        400,
        450,
        500,
        550,
        600,
        650,
        700,
        750,
        800,
        850,
        900,
        950,
        1000,
        1050,
        1100,
        1200,
        1500,
        2000,
        3000,
        4000,
        5000,
        6000,
        7000,
        8000,
        9000,
        10000,
        15000,
        20000,
        100000,
      ];

      this.values = possibleValues.filter((value) => value <= this.maxPrice);
      // Encontrar el siguiente valor mayor a maxPrice, si existe
      const nextValue = possibleValues.find((value) => value > this.maxPrice);

      // Si hay un valor siguiente, añadirlo a la lista
      if (nextValue !== undefined) {
        this.values.push(nextValue);
      }
    },

    initializeSliderState() {
      const maxIndex = this.values.length - 1;
      var selectedMaxIndex = maxIndex;
      if (this.filterMaxPrice) {
        const maxPrice = Math.min(
          ...this.values.filter((num) => num >= this.filterMaxPrice)
        );
        selectedMaxIndex = this.values.findIndex((num) => num === maxPrice);
      }

      this.sliderPriceTwoValue =
        selectedMaxIndex && selectedMaxIndex > 0 ? selectedMaxIndex : maxIndex;
      this.sliderPriceTwoValueOld = this.sliderPriceTwoValue;
      this.sliderMaxValuePrice = maxIndex;

      this.slideOnePrice();
      this.slideTwoPrice();
      this.fillColorPrice();
    },

    onResize() {
      this.isMobile = window.innerWidth <= 767
    },
    replaceItemLabel(label) {
      if (label === "« Previous") {
        return "<";
      }
      if (label === "Next »") {
        return ">";
      }
      return label;
    },
    mapChildren: function(elements, level = "activity") {
      return elements.map((element) => ({
        title: element.translation.name,
        key: `${level}-${element.codeElement}`,
        disabled: false,
        children: element.childs ? mapChildren(element.childs, "child") : [],
      }));
    },

    convertPrice(value) {
      let i = parseInt(value);
      return this.values[i];
    },
    printOnePrice() {
      const formatter = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });

      // Actualizar el texto del precio
      this.sliderPriceOneText = formatter.format(
        this.convertPrice(this.sliderPriceOneValue)
      );

      // Actualizar el color del slider
      this.fillColorPrice();
    },
    printTwoPrice() {
      const formatter = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });

      // Determinar el texto del precio
      const priceValue =
        this.sliderPriceTwoValue === this.sliderMaxValuePrice
          ? `+${formatter.format(this.convertPrice(this.sliderMaxValuePrice))}`
          : formatter.format(this.convertPrice(this.sliderPriceTwoValue));

      this.sliderPriceTwoText = priceValue;

      // Actualizar el color del slider
      this.fillColorPrice();
    },
    slideOnePrice() {
      // Guardar el valor anterior
      this.sliderPriceOneValueOld = this.sliderPriceOneValue;

      // Verificar el espacio mínimo
      if (
        this.sliderPriceTwoValue - this.sliderPriceOneValue <=
        this.minGapPrice
      ) {
        this.sliderPriceOneValue = this.sliderPriceTwoValue - this.minGapPrice;
      }

      // Actualizar el precio mostrado
      this.printOnePrice();
    },
    slideTwoPrice() {
      // Guardar el valor anterior
      this.sliderPriceTwoValueOld = this.sliderPriceTwoValue;

      // Verificar el espacio mínimo
      if (
        this.sliderPriceTwoValue - this.sliderPriceOneValue <=
        this.minGapPrice
      ) {
        this.sliderPriceTwoValue = this.sliderPriceOneValue + this.minGapPrice;
      }

      // Actualizar el precio mostrado
      this.printTwoPrice();
    },
    fillColorPrice() {
      let vm = this;
      let percent1 = (vm.sliderPriceOneValue / vm.sliderMaxValuePrice) * 100;
      let percent2 = (vm.sliderPriceTwoValue / vm.sliderMaxValuePrice) * 100;
      vm.myStylePrice.background =
        "linear-gradient(to right, #DDDDDD " +
        percent1 +
        "% , #A6342F " +
        percent1 +
        "% , #A6342F " +
        percent2 +
        "%, #DDDDDD " +
        percent2 +
        "%)";
    },
    onLangsPageChange(toPage, fromPage) {
      this.$nextTick(() => {
        try {
          var listadoProductos = document.getElementById("listado_productos");
          var scrollPosition = listadoProductos.offsetTop - 60;
          window.scrollTo({
            top: scrollPosition,
            behavior: "smooth",
          });
        } catch (error) {}
      });
    },
    cmp(a, b) {
      if (a > b) return +1;
      if (a < b) return -1;
      return 0;
    },

    handleVisibleTemplate(template) {
      this.templateVal = template;
    },
    onBrandCheck(cKeys) {
      this.checkedBrandKeys = cKeys;
    },

    handleUpdatePrice(prices, product) {
      this.$set(product, "price_", prices.price);
      this.$set(
        product,
        "price_without_discount_",
        prices.price_without_discount
      );
      this.$set(product, "discount_", prices.discount);
    },

    handleProductAdded(product) {
      this.selled_products = [];
      this.added_product = product;
      this.$nextTick(() => {
        $("#addedProductModal").modal("show");
      });
    },

    handleSelledProducts(products) {
      this.selled_products = products;
    },

    scrollIfHasParams() {
      let url = window.location.href;
      if (url.includes("?")) {
        const element = document.querySelector("#listado_productos");
        const headerHeight = 100; // Cambia este valor al tamaño exacto de tu header fijo

        if (element) {
          const elementPosition =
            element.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = elementPosition - headerHeight;

          // Desplazamiento manual
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      }
    },
  },
};
</script>

<style></style>
